<app-modal-base>
    <div class="loading-dialog">
        Carregando...
        <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    </div>
</app-modal-base>